import React, { useEffect, useState } from "react";
import { Eye, Loader2, RotateCw } from "lucide-react";
import { errMsg, reApi } from "@/lib/residentApi";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const endSession = (token) => fetch(`${API}/re/portal-session?token=${encodeURIComponent(token)}`, {
  method: "DELETE", keepalive: true, headers: { Authorization: `Bearer ${localStorage.getItem("nex_token") || ""}` } }).catch(() => {});

/** The resident's real PACT Life Pass in a phone frame; every change is recorded as the staff member, for the resident. */
export default function LifePassTab({ resident }) {
  const [session, setSession] = useState(null);
  const [error, setError] = useState(null);
  const [nonce, setNonce] = useState(0);
  useEffect(() => {
    if (resident.status !== "active") return undefined;
    let tok = null;
    let gone = false;
    setSession(null); setError(null);
    reApi.post(`/residents/${resident.id}/portal-session`, {})
      .then((s) => { tok = s.token; if (gone) endSession(tok); else setSession(s); })
      .catch((e) => !gone && setError(errMsg(e)));
    const onHide = () => tok && endSession(tok);
    window.addEventListener("pagehide", onHide);
    return () => { gone = true; window.removeEventListener("pagehide", onHide); onHide(); };
  }, [resident.id, resident.status, nonce]);

  if (resident.status !== "active") return <p data-testid="lifepass-tab-inactive" className="text-sm text-nex-muted">Only active residents have a PACT Life Pass.</p>;
  return (
    <div data-testid="lifepass-tab" className="flex flex-col items-center gap-3">
      <div data-testid="lifepass-tab-bar" className="w-full max-w-[400px] flex items-center gap-2 px-3 py-1.5 rounded-sm bg-nex-gold text-black">
        <Eye className="h-3.5 w-3.5 shrink-0" />
        <span className="flex-1 min-w-0 truncate text-xs font-semibold">Live · changes are real, logged as you</span>
        <button type="button" onClick={() => setNonce((n) => n + 1)} data-testid="lifepass-tab-reload" title="Reload"
          className="h-7 w-7 grid place-items-center rounded-sm border border-black/40 hover:bg-black/10"><RotateCw className="h-3 w-3" /></button>
      </div>
      <div data-testid="lifepass-phone" className="w-full max-w-[400px] rounded-[2.2rem] border-[10px] border-[#05080f] bg-[#05080f] shadow-[0_20px_60px_rgba(0,0,0,0.55)] ring-1 ring-white/10 overflow-hidden">
        <div className="h-5 flex justify-center items-start"><span className="mt-1 h-1.5 w-20 rounded-full bg-white/10" /></div>
        <div className="h-[min(760px,calc(100vh-300px))] min-h-[460px] bg-[#0B1220] rounded-[1.4rem] overflow-hidden">
          {error ? <p data-testid="lifepass-tab-error" className="p-5 text-sm text-red-300">{error}</p>
            : !session ? <div className="h-full grid place-items-center text-nex-muted"><Loader2 className="h-5 w-5 animate-spin" /></div>
            : <iframe key={session.token} data-testid="lifepass-tab-frame" title={`PACT Life Pass · ${session.resident.name}`} src={session.path} className="w-full h-full border-0" />}
        </div>
      </div>
    </div>
  );
}
